export default {"src":"/_next/static/media/header_bg_vertical.75e13994.svg","height":199,"width":2,"blurWidth":0,"blurHeight":0};